////////////////////////////////////////////////////////////
//  Program: Inventory.jsx                                //
//  Application: KINI HTML                                //
//  Option: Home Sharing Listing                          //
//  Developer: PS		                                      //
//  Date: 2022-04-21                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import CommonHeader from "../common/CommonHeader";
import Moment from "moment";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutFormParking from "./CheckoutFormParking";
import CmsDataService from "../../services/CmsDataService";
import { Modal, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import queryString from "query-string";
const queryParams = queryString.parse(location.search);
import ReservationService from "../../services/ReservationService";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class Parking extends Component {
  constructor(props) {
    super(props);
    const tripDetailsRaw = localStorage.getItem("trip_details");
    let tripDetails = null;
    try {
      tripDetails = tripDetailsRaw ? JSON.parse(tripDetailsRaw) : null;
    } catch (e) {
      tripDetails = null;
    }

    this.state = {
      currentData: tripDetails,
      headerToken: localStorage.getItem("headerToken")
        ? localStorage.getItem("headerToken")
        : "",
      is_form_submited: localStorage.getItem("is_form_submited")
        ? localStorage.getItem("is_form_submited")
        : "",
      parking_payment: localStorage.getItem("parking_payment")
        ? localStorage.getItem("parking_payment")
        : "",
      today: Moment(new Date()).format("YYYY-MM-DD H:m:s"),
      maxVehicle: 1,
      no_of_vehicle: 1,
      no_of_vehicle_error: "",
      vehicleDetails: [{ vehicle_make: "", vehicle_model: "", vehicle_color: "", license_plate_number: "" }],
      vehicleFormError: "",
      currentStep: 1,
      // webview=1 when opened from the Android app; affects UI layout decisions.
      webview: queryParams.webview ? queryParams.webview : 1,
      confirmation_code:
        props.match && props.match.params
          ? props.match.params.confirmationCode
          : "",
    };
    this.getReservationDetails = this.getReservationDetails.bind(this);
    this.getclientToken = this.getclientToken.bind(this);
  }

  async componentDidMount() {
    await this.getReservationDetails();

    // 200ms delay allows getReservationDetails state updates to settle before
    // reading maxVehicle from currentData — avoids reading stale initial value.
    setTimeout(() => {
      const maxVehicle = this.state.currentData?.maxVehicle;
      this.setState((prevState) => ({
        maxVehicle: maxVehicle,
      }));
      this.setState({ currentStep: 1 });
    }, 200);
  }

  onBackButtonEvent = () => {
    this.props.history.push("/reservation-list");
  };

  getReservationDetails = async () => {
    var list = [];
    var record = [];
    var totalRecords = 0;
    var parking_fee_stripe = "";
    var property_parking_fee = "";
    var total_stay_nights = "";
    var parking_instruction = "";
    var reservation_slug = "";
    var guest_slug = "";
    var customer_id = "";
    this.setState({ loader: true });
    var data = {
      confirmation_code: this.state.confirmation_code,
      last_name: "",
      email: "",
      property_seo_slug: "",
      user_slug: "",
      filter_by: 4,
    };
    let res = await ReservationService.getMyBookReservation(data);
    const hasTripDetailsInState =
      this.state.currentData && Object.keys(this.state.currentData).length > 0;
    const shouldUseApiDataForCurrentData = !hasTripDetailsInState;
    if (global.successStatus.includes(res.status) && res.data.length !== 0) {
      list = res.data ? res.data : [];
      parking_fee_stripe = res.data ? res.data.parking_fee_stripe : "";
      reservation_slug = res.data ? res.data.slug : "";
      guest_slug =
        res.data && res.data.guest_user ? res.data.guest_user?.slug : "";
      customer_id =
        res.data && res.data.guest_user
          ? res.data.guest_user?.stripe_customer_id
          : "";
      property_parking_fee = res.data ? res.data.property_parking_fee : "";
      total_stay_nights = res.data ? res.data.total_stay_nights : "";
      parking_instruction = res.data
        ? res.data?.property?.parking_payment_instructions
        : "";
      record = res.data ? res.data : [];
      this.setState({ loader: false });
      totalRecords = res.data ? res.data.total : 0;
    }
    if (global.successStatus.includes(res.status) && res.data.length !== 0) {
      await this.setState({
        total_record: totalRecords,
        reservationList: list,
        currentData: shouldUseApiDataForCurrentData
          ? list
          : this.state.currentData,
        parking_fee_stripe: parking_fee_stripe,
        property_parking_fee: property_parking_fee,
        total_stay_nights: total_stay_nights,
        parking_instruction: parking_instruction,
        reservation_slug: reservation_slug,
        guest_slug: guest_slug,
        customer_id: customer_id,
        loader: false,
      });
      await localStorage.setItem("trip_details", JSON.stringify(list));
      // this.getclientToken();
      this.setState({ reservationDetail: true, errorMsg: "" });
    } else {
      this.setState({
        errorMsg:
          "Details entered by you are incorrect. Please verify your confirmation code and last name you have used during booking.",
      });
    }

    this.setState({ loader: false });
  };

  getclientToken = async (queryString = "") => {
    this.setState({ vehicleFormError: "" });
    this.setState({
      showSpinner: true,
      loading: true,
      currentStep: 3,
    });
    var resData = {};
    var resDataArr = [];
    var stripe_id = [];
    var baseParkingAmount = this.state.currentData
      ? global.OnKeyPressEvent.numberWithCommasForDecimal(
          parseFloat(this.state.currentData?.parking_fee_stripe)
            .toFixed(2)
            .replace(/\.00$/, ""),
        )
      : parseInt(0).toFixed(2);
    const quantity = parseInt(this.state.no_of_vehicle, 10) || 1;

    const parkingAmount = quantity * baseParkingAmount;

    // Free parking: skip Stripe, call existing save endpoints directly
    if (parseFloat(parkingAmount) === 0) {
      const saveRes = await ReservationService.AddParkingData({
        confirmation_code: this.state.confirmation_code,
        stripe_transaction_id: "",
        amount: 0,
        no_of_vehicle: this.state.no_of_vehicle,
        is_free_parking: 1,
      });
      if (global.successStatus.includes(saveRes.status)) {
        await ReservationService.UpdateCarcolor({
          confirmation_code: this.state.confirmation_code,
          vehicle_details: this.state.vehicleDetails,
        });
        localStorage.setItem("parking_payment", 1);
        window.location.href = global.themeUrl + "reservation-details";
      } else {
        this.setState({
          vehicleFormError: "Unable to save parking. Please try again.",
          showSpinner: false,
          loading: false,
        });
      }
      return;
    }

    let inputData = {
      customer_id: this.state.currentData?.guest_user?.stripe_customer_id,
      payment: parkingAmount,
      guest_slug: this.state.currentData?.guest_user?.slug,
      reservation_slug: this.state.currentData?.slug,
      quantity: quantity,
    };
    let res = await CmsDataService.getParkingclientToken(inputData);
    if (global.successStatus.includes(res.status)) {
      resDataArr = res.data ? res.data[0] : [];
      stripe_id = res.data ? res.data[1] : [];
    }
    await this.setState({
      clientToken: resDataArr,
      stripe_id: stripe_id,
      parkingAmount: parkingAmount,
    });
  };

  verifyNoOfVehicle = async () => {
    this.setState({ loader: true });
    let no_of_vehicle = this.state.no_of_vehicle;
    let no_of_vehicle_error = null;
    if (no_of_vehicle === "" || no_of_vehicle === 0 || no_of_vehicle < 1) {
      this.setState({
        no_of_vehicle_error: `Minimum 1 vehicle is required`,
      });
    } else if (no_of_vehicle > this.state.maxVehicle) {
      no_of_vehicle_error = `You can only select ${this.state.maxVehicle} vehicle`;
      this.setState({
        loader: false,
        no_of_vehicle_error: no_of_vehicle_error,
      });
      return false;
    } else {
      this.setState({ no_of_vehicle_error: null, verifyNoOfVehicle: true });
    }

    this.setState({ loader: false });
  };

  manageVerifyModal = (value = false) => {
    this.setState({
      verifyNoOfVehicle: value,
    });
  };

  onVehicleDetailChange = (index, field, value) => {
    const vehicleDetails = this.state.vehicleDetails.map((v, i) =>
      i === index ? { ...v, [field]: value } : v
    );
    this.setState({ vehicleDetails });
  };

  goToStep2 = () => {
    const { no_of_vehicle, maxVehicle } = this.state;
    if (!no_of_vehicle || no_of_vehicle < 1 || no_of_vehicle > maxVehicle) {
      this.setState({ no_of_vehicle_error: `Please select between 1 and ${maxVehicle}` });
      return;
    }
    this.setState({ no_of_vehicle_error: "", currentStep: 2 });
  };

  goToStep1 = () => {
    this.setState({ currentStep: 1 });
  };

  goToStep2FromPayment = () => {
    this.setState({ currentStep: 2, clientToken: null });
  };

  editablePhone = () => {
    this.setState({ editablePhone: true });
  };

  changeHandler = (event) => {
    this.setState({ no_of_vehicle_error: null });
    let input = this.state.input;
    let value = event.target.value;
    if (event.target.name === "no_of_vehicle") {
      if (value === "" || value === 0 || value < 1) {
        this.setState({
          no_of_vehicle_error: `Minimum 1 vehicle is required`,
        });
      }
      if (parseInt(value) > parseInt(this.state.maxVehicle)) {
        this.setState({
          no_of_vehicle_error: `You can only select ${this.state.maxVehicle} vehicle`,
        });
      }
    }
    this.setState({ [event.target.name]: value, input: input });
  };

  handleChange = (event) => {
    const value = parseInt(event.target.value, 10);
    const { maxVehicle, vehicleDetails } = this.state;

    if (value < 1 || value > maxVehicle) {
      this.setState({ no_of_vehicle_error: `Please select between 1 and ${maxVehicle}` });
      return;
    }

    let newDetails;
    if (value > vehicleDetails.length) {
      const extra = Array.from(
        { length: value - vehicleDetails.length },
        () => ({ vehicle_make: "", vehicle_model: "", vehicle_color: "", license_plate_number: "" })
      );
      newDetails = [...vehicleDetails, ...extra];
    } else {
      newDetails = vehicleDetails.slice(0, value);
    }

    this.setState({ no_of_vehicle: value, no_of_vehicle_error: "", vehicleDetails: newDetails });
  };

  render() {
    const options = {
      clientSecret: this.state.clientToken,
      appearance: {
        /*...*/
      },
    };
    const parkingFeedisplay = this.state.currentData
      ? global.OnKeyPressEvent.numberWithCommasForDecimal(
          parseFloat(this.state.currentData?.property_parking_fee)
            .toFixed(2)
            .replace(/\.00$/, ""),
        )
      : parseInt(0).toFixed(2);
    const numberOfdays = this.state.currentData?.total_stay_nights;
    const parkingAmount = this.state.currentData
      ? global.OnKeyPressEvent.numberWithCommasForDecimal(
          parseFloat(this.state.currentData?.parking_fee_stripe)
            .toFixed(2)
            .replace(/\.00$/, ""),
        )
      : parseInt(0).toFixed(2);
    return (
      <>
        <main className="oh-template Brandmainpage wizard_header wzard_main_bg parking_via_web">
          {this.state.webview === 1 ? <CommonHeader /> : ""}

          <section className="wizard_sec">
            <div className="row- wizard_row m-0 mobView">
              <div className="wizard_box ">
                <div className="wizard-data req_book_secw-zaed">
                  <div className="container-fluid p-0 parking_page">
                    <section className="wzrd_main_section">
                      <div className="container">
                        <div className="content">
                          <div className="row mobView wizard_new_heading">
                            <div
                              className={
                                this.state.currentStep < 3
                                  ? "wzrd_middle_desk park-full"
                                  : "wzrd_middle_desk2"
                              }
                            >
                              {/* ── STEP 1: Parking info, price panel, vehicle count ── */}
                              {this.state.currentStep === 1 && (
                                <>
                                  <div className="col-sm-12 col-lg-12 bg_wzrd_heading mob_sticky_top">
                                    <div className="wzrd_heading_box col-12 m-0 ">
                                      <h4>
                                        {/* {this.state.currentData?.parking_screen_stripe_titles ? this.state.currentData?.parking_screen_stripe_titles : "Parking Payment" } */}
                                        { (parkingFeedisplay > 0) ? `Parking Payment` : `Parking Details`}
                                      </h4>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-lg-12 bg_wzrd_heading ">
                                    <div className="wzrd_heading_box col-12 mb-0">
                                      <div className="col-xs-12 col-sm-12 col-md-12 p-0 mg-b-0 check_wizard upload_info_detail ">
                                        <p>
                                          {" "}
                                          <b className="doc_upload_heading pt-0 parking-head-text">
                                            {
                                              (parkingFeedisplay > 0) ?
                                              `Would you like to access parking instructions for $ ${parkingFeedisplay} /night` :
                                              `Would you like to access parking instructions`
                                            }
                                          </b>{" "}
                                        </p>
                                        <ul className="parking_list_sty">
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                this.state.currentData?.property
                                                  ?.parking_payment_instructions ||
                                                "",
                                            }}
                                          ></p>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                                    <div className="parking_price_box">
                                      <div className="wzrd_heading_box col-12 ">
                                        <div className="wzrd_mid_heading pt-0 border-0">
                                          <h5 className="pt-0">
                                            { (parkingFeedisplay > 0) ? `Parking price details` : ``}                                            
                                          </h5>
                                          <div className="mt-3">
                                            <ul className="parking_pay_detail">
                                              { (parkingFeedisplay > 0) && 
                                                <li>
                                                  <span>
                                                    ${parkingFeedisplay} x{" "}
                                                    {numberOfdays > 1
                                                      ? numberOfdays + " nights"
                                                      : numberOfdays + " night"}
                                                  </span>
                                                  <span>${parkingAmount}</span>
                                                </li>
                                              }
                                              <li>
                                                <span>No. of Vehicle</span>
                                                <FormControl
                                                  error={
                                                    !!this.state
                                                      .no_of_vehicle_error
                                                  }
                                                >
                                                  <Select
                                                    className="parking_car"
                                                    id="demo-simple-select"
                                                    label="No. of Vehicle"
                                                    value={
                                                      this.state.no_of_vehicle
                                                    }
                                                    name="no_of_vehicle"
                                                    onChange={this.handleChange}
                                                  >
                                                    <MenuItem disabled value="">
                                                      Select number of vehicles
                                                    </MenuItem>
                                                    {Array.from(
                                                      {
                                                        length:
                                                          this.state.maxVehicle,
                                                      },
                                                      (_, i) => i + 1,
                                                    ).map((value) => (
                                                      <MenuItem
                                                        key={value}
                                                        value={value}
                                                      >
                                                        {value}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                </FormControl>
                                                {this.state
                                                  .no_of_vehicle_error && (
                                                  <p
                                                    style={{
                                                      color: "red",
                                                      marginTop: "4px",
                                                    }}
                                                  >
                                                    {
                                                      this.state
                                                        .no_of_vehicle_error
                                                    }
                                                  </p>
                                                )}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        { (parkingFeedisplay > 0) && 
                                          <div className="wzrd_mid_heading pt-0 ">
                                            <div className="parking_total">
                                              <ul className="parking_pay_detail">
                                                <li className="parking_total_price">
                                                  <span>Total (USD)</span>
                                                  <span>
                                                    $
                                                    {parkingAmount *
                                                      this.state.no_of_vehicle}
                                                  </span>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        }
                                        <div className="mg-t-30 reservationBook bg-white">
                                          <button
                                            className="w-100"
                                            onClick={this.goToStep2}
                                          >
                                            Next
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {/* ── STEP 2: Vehicle details form ── */}
                              {this.state.currentStep === 2 && (
                                <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                                  <div className="wzrd_heading_box col-12 mb-0">
                                    <div className="col-xs-12 col-sm-12 col-md-12 mg-b-0 mg-t-20">
                                      <p className="addons_subtitle mt-3 mb-3">Please enter the details for each vehicle.</p>
                                      {this.state.vehicleDetails.map((vehicle, index) => (
                                        <div key={index}>
                                          {index > 0 && <hr className="my-3" />}
                                          <h6 className="mb-3">Vehicle {index + 1}</h6>
                                          <div className="row">
                                            <div className="col-12 col-md-3">
                                              <div className="car_color_type">
                                                <span className="pd-t-20 pd-b-0 labelTitle position-relative">Make</span>
                                                <div className="form-group">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={vehicle.vehicle_make}
                                                    onChange={(e) => this.onVehicleDetailChange(index, "vehicle_make", e.target.value)}
                                                    placeholder="e.g. Toyota"
                                                    autoComplete="off"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                              <div className="car_color_type">
                                                <span className="pd-t-20 pd-b-0 labelTitle position-relative">Model</span>
                                                <div className="form-group">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={vehicle.vehicle_model}
                                                    onChange={(e) => this.onVehicleDetailChange(index, "vehicle_model", e.target.value)}
                                                    placeholder="e.g. Camry"
                                                    autoComplete="off"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                              <div className="car_color_type">
                                                <span className="pd-t-20 pd-b-0 labelTitle position-relative">Color</span>
                                                <div className="form-group">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={vehicle.vehicle_color}
                                                    onChange={(e) => this.onVehicleDetailChange(index, "vehicle_color", e.target.value)}
                                                    placeholder="e.g. Silver"
                                                    autoComplete="off"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                              <div className="car_color_type">
                                                <span className="pd-t-20 pd-b-0 labelTitle position-relative">License Plate</span>
                                                <div className="form-group">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={vehicle.license_plate_number}
                                                    onChange={(e) => this.onVehicleDetailChange(index, "license_plate_number", e.target.value)}
                                                    placeholder="e.g. ABC-1234"
                                                    autoComplete="off"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                      {this.state.vehicleFormError && (
                                        <p className="text-danger mt-2">{this.state.vehicleFormError}</p>
                                      )}
                                    </div>
                                    <div className="step_btns mg-t-30">
                                      <button
                                        className="w-100 btn_pre_wzd"
                                        onClick={this.goToStep1}
                                      >
                                        Previous
                                      </button>
                                      <button
                                        className="w-100 btn_next_wzd"
                                        disabled={this.state.loader ? true : false}
                                        onClick={() => this.getclientToken()}
                                      >
                                        { (parkingFeedisplay > 0) ? `Continue to Payment{" "}` : `Save`}
                                        
                                        {this.state.loader ? (
                                          <>
                                            <Spinner
                                              as="span"
                                              animation="grow"
                                              role="status"
                                              aria-hidden="true"
                                            />
                                            <Spinner
                                              as="span"
                                              animation="grow"
                                              role="status"
                                              aria-hidden="true"
                                            />
                                            <Spinner
                                              as="span"
                                              animation="grow"
                                              role="status"
                                              aria-hidden="true"
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* ── STEP 3: Stripe payment ── */}
                              {this.state.currentStep === 3 && (
                                <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                                  <div className="wzrd_heading_box col-12 mb-0">
                                    <div className="col-xs-12 col-sm-12 col-md-12 mg-b-0 strip_parking">
                                      {!this.state.clientToken ? (
                                        <div>
                                          <h3>Loading...</h3>
                                        </div>
                                      ) : (
                                        <div className="col-xs-12 col-sm-12 col-md-12 pd-l- pd-r-">
                                          <Elements
                                            stripe={stripePromise}
                                            options={options}
                                          >
                                            <CheckoutFormParking
                                              guest_slug={this.state.guest_slug}
                                              reservation_slug={
                                                this.state.reservation_slug
                                                  ? this.state.reservation_slug
                                                  : ""
                                              }
                                              amount={
                                                this.state.parkingAmount
                                                  ? this.state.parkingAmount
                                                  : ""
                                              }
                                              stripe_id={this.state.stripe_id}
                                              confirmation_code={this.state.confirmation_code}
                                              no_of_vehicle={
                                                this.state.no_of_vehicle
                                              }
                                              vehicleDetails={this.state.vehicleDetails}
                                              onPrevious={this.goToStep2FromPayment}
                                            />
                                          </Elements>
                                        </div>
                                      )}
                                      <p className="error-message"></p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </>
    );
  }
}
export default Parking;
